












import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { PayoutRequest, PayoutRequestSearchResponse } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import providers from "@/lib/api";
import PayoutRequestsView from "./components/PayoutRequestsView.vue";

const usePendingPrimaryBalance = () => {
  const { balance, getBalance } = useBalance();
  const { authUserStrict } = useAuthUser();
  const pendingBalance = ref<number>(0);
  const primaryBalance = computed<number>(() => balance.value - pendingBalance.value);
  const getPendingBalance = async () => {
    const balance = await providers.TransactionProvider.getPendingBalance({ userIds: [authUserStrict.value.id] });
    pendingBalance.value = balance[authUserStrict.value.id];
  };
  watch(
    balance,
    () => {
      getPendingBalance();
    },
    { immediate: true }
  );

  return {
    pendingBalance,
    primaryBalance,
    getBalance,
  };
};

export default defineComponent({
  name: "PagePayoutRequests",
  components: { PayoutRequestsView },
  setup() {
    const { getBalance, pendingBalance, primaryBalance } = usePendingPrimaryBalance();
    const { authUserStrict } = useAuthUser();
    return { getBalance, authUserStrict, pendingBalance, primaryBalance };
  },
  data() {
    return {
      loading: false,
      enableScroll: false,
      payoutRequestSearchResponse: null as PayoutRequestSearchResponse | null,
    };
  },
  computed: {
    requestsList(): PayoutRequest[] {
      return this.payoutRequestSearchResponse?.result ?? [];
    },
    hasActiveRequest(): boolean {
      return this.requestsList.some(i => i.status === "NEW") ?? false;
    },
  },
  methods: {
    async getPayoutRequest(page: number = 0, replace: boolean = true) {
      try {
        this.enableScroll = false;
        const data = await providers.PayoutRequestsProvider.search({
          data: { userId: this.authUserStrict.id, page, sort: "TIME,DESC" },
        });
        if (!replace && this.payoutRequestSearchResponse) {
          data.result = [...this.payoutRequestSearchResponse.result, ...data.result];
        }
        this.payoutRequestSearchResponse = data;
      } finally {
        this.enableScroll = this.payoutRequestSearchResponse?.hasNextPage ?? false;
      }
    },
    getNextData(cb?: Function) {
      const page = (this.payoutRequestSearchResponse?.page ?? 0) + 1;
      this.getPayoutRequest(page, false).finally(() => cb && cb());
    },
    onCreateRequest(value: PayoutRequest) {
      if (this.payoutRequestSearchResponse?.hasNextPage) {
        this.payoutRequestSearchResponse?.result.pop();
        this.payoutRequestSearchResponse?.result.unshift(value);
      } else {
        this.payoutRequestSearchResponse?.result.unshift(value);
      }
    },
  },
  async created() {
    try {
      this.loading = true;
      await Promise.all([this.getPayoutRequest(), this.getBalance()]);
    } finally {
      this.loading = false;
    }
  },
});
